import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteAttachmentByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteAttachmentByIdMutation = { __typename?: 'mutation_root', delete_product_attachments_by_pk?: { __typename?: 'product_attachments', id: any } | null };


export const DeleteAttachmentByIdDocument = gql`
    mutation deleteAttachmentById($id: uuid!) {
  delete_product_attachments_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteAttachmentByIdMutationFn = Apollo.MutationFunction<DeleteAttachmentByIdMutation, DeleteAttachmentByIdMutationVariables>;

/**
 * __useDeleteAttachmentByIdMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentByIdMutation, { data, loading, error }] = useDeleteAttachmentByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttachmentByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentByIdMutation, DeleteAttachmentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentByIdMutation, DeleteAttachmentByIdMutationVariables>(DeleteAttachmentByIdDocument, options);
      }
export type DeleteAttachmentByIdMutationHookResult = ReturnType<typeof useDeleteAttachmentByIdMutation>;
export type DeleteAttachmentByIdMutationResult = Apollo.MutationResult<DeleteAttachmentByIdMutation>;
export type DeleteAttachmentByIdMutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentByIdMutation, DeleteAttachmentByIdMutationVariables>;